/* prettier-ignore */

import { Component, computed } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { GamificationService } from 'src/app/shared/gamification/services/gamification.service';
import { AuthService } from 'src/app/auth/services';
import { GoogleTranslateService } from 'src/app/services/google-translate.service';
import { ToolsService } from 'src/app/services/tools.service';
import { UserService } from 'src/app/user/services';
import { RegisterComponent } from 'src/app/shared/register/register.component';

@Component({
  selector: 'header-user-menu',
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss',
})

export class HeaderUserMenuComponent {
  public passportEnabled = computed(() => this._gamificationService.passportsEnabled());

  constructor(
    public googleTranslateService: GoogleTranslateService,
    public translate: TranslateService,
    public authService: AuthService,
    public tools: ToolsService,
    private userService: UserService,
    private modalCtrl: ModalController,
    private _gamificationService: GamificationService
  ) {}
  
  protected user = this.authService.user;

  async register(){
      this.modalCtrl.dismiss().catch(e => {
          console.warn("No modal found on dismiss")
      });
      const registerModal = await this.modalCtrl.create({
          component: RegisterComponent,
          cssClass: ['registerModal', 'ion-disable-focus-trap'],
      });
      await registerModal.present();
  }

  login(){
      this.userService.login();
  }

  logout(){
      this.authService.logout();
      this.userService.resetAll();
  }
  
  protected getUserIconLetter(): string {
    const user = this.user();
    if(!user) return '';
    
    const userName = user.name;
    const userEmail = user.email;
    
    if (userName && userName.length > 0) {
      return userName.charAt(0).toUpperCase();
    } else if (userEmail && userEmail.length > 0) {
      return userEmail.charAt(0).toUpperCase();
    } else {
      return '';
    }
  }
}